module.exports = __webpack_public_path__ + "img/download-new-gray.ac727aa6.svg";